<template>
  <div id="inspection-status">
    <v-container fluid>
      <!-- breadcrum and previous router -->
      <div class="breadcrumb-header">
        <v-btn text small icon color="primary" @click="$router.go(-1)">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-breadcrumbs :items="breadcrumbItems" divider="/"></v-breadcrumbs>
      </div>

      <!-- filter -->
      <v-card class="mx-auto" outlined>
        <div class="card-sub-label">Filter by:</div>

        <v-row flex class="fliter-box">
          <v-col
            cols="12"
            xs="12"
            sm="6"
            md="3"
            class="custom-col"
            v-for="(filter, i) in Object.keys(level_list)"
            :key="i"
          >
            <v-autocomplete
              dense
              :items="level_list[filter]"
              item-text="name"
              item-value="_id"
              :label="filter"
              v-model="filter_items[filter]"
              outlined
              clearable
              color="appcolor"
              @input="selectSeacrhChange(filter_items[filter], filter)"
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-card>
      <br />
      <!-- table -->
      <v-data-table
        :headers="tableProps.headers"
        :items="tableProps.items"
        :loading="tableProps.loading"
        loading-text="Loading... Please wait"
        :items-per-page="5"
        class="elevation-1"
      >
        <!-- table index -->
        <template
          v-slot:item.index="{ item }"
        >{{tableProps.items.map(function(x) {return x; }).indexOf(item) + 1}}</template>

        <!-- Aerodyne Approval with download link custom -->
        <template v-slot:item.aerodyne_approval="{ item }">
          {{(item.aerodyne_approval_status) ? item.aerodyne_approval_status + ' by: ' + item.aerodyne_approved_by.name : ''}}
          <a
            v-if="item.aerodyne_approved_by.name && item.aerodyne_doc_url"
            style="text-decoration: none;"
            :href="reportBase+item.aerodyne_doc_url"
            target="_new"
          >
            <v-icon>mdi-download</v-icon>
          </a>
        </template>

        <!-- TNB Approval with download link custom -->
        <template v-slot:item.tnb_approval="{ item }">
          {{(item.approval_status) ? item.approval_status + ' by: ' + item.approved_by.name : ''}}
          <a
            v-if="item.approved_by.name && item.doc_url"
            style="text-decoration: none;"
            :href="reportBase+item.doc_url"
            target="_new"
          >
            <v-icon>mdi-download</v-icon>
          </a>
        </template>

        <!-- table action -->
        <template v-slot:item.action="{ item }">
          <div v-if="item.aerodyne_approval_status!='approved'">
            <v-btn
              v-if="tableProps.action_button_edit"
              text
              icon
              class="mr-2"
              color="success"
              title="Approve"
              @click="reportModal('Approve', item)"
            >
              <v-icon small>mdi-check</v-icon>
            </v-btn>
            <v-btn
              v-if="tableProps.action_button_edit"
              text
              icon
              class="mr-2"
              color="warning"
              title="Rework"
              @click="reportModal('Rework',item)"
            >
              <v-icon small>mdi-redo-variant</v-icon>
            </v-btn>
          </div>
          <div
            v-else-if="(item.approval_status =='approved' && !item.doc_url) || (item.aerodyne_approval_status =='approved' && !item.aerodyne_doc_url)"
          >
            <v-btn
              v-if="tableProps.action_button_edit"
              text
              icon
              class="mr-2"
              color="info"
              title="Upload"
              @click="reportModal('Upload',item)"
            >
              <v-icon small>mdi-upload</v-icon>
            </v-btn>
          </div>
          <div v-else>No action needed</div>
        </template>
      </v-data-table>

      <!-- Form Approve/Reject dialog -->
      <customDialog :dialogProps="dialogProps" v-if="(isApproveModalShown || isRejectModalShown) && !isUploadShown">
        <!-- title card -->
        <span
          slot="card-title"
          class="captalize"
        >{{(isApproveModalShown) ? `Aerodynet - Inspection Approval Form` : `Aerodynet - Inspection Rework Form`}}</span>
        <!-- card body -->
        <span slot="card-body">
          <!-- form for add or edit or delete -->
          <v-form ref="form_1" v-model="valid" autocomplete="off">
            <v-row>
              <v-col cols="12">
                Inspection :
                <span
                  v-for="(insp, i) in form.inspection"
                  :key="i"
                >"{{insp.inspection_date}}"</span>
                <!-- <v-text-field label="Inspection" v-model="form.inspection.inspection_date" :rules="form.inspection" dense disabled></v-text-field> -->
              </v-col>
              <v-col cols="12">Report : {{form.report}}</v-col>
              <v-col cols="12">
                <v-textarea
                  outlined
                  label="Comments"
                  v-model="form.comments"
                  :rules="rules.comments"
                ></v-textarea>
              </v-col>
              <v-col cols="12"  v-show="isApproveModalShown" >
                <v-file-input
                  label=" Completion Form"
                  type="file"
                  accept=".pdf"
                  @change="handleFileUpload"
                ></v-file-input>
              </v-col>
            </v-row>
          </v-form>
        </span>
        <!-- card action buttons -->
        <span slot="card-action">
          <v-btn text @click="dialogProps.dialog = false" :disabled="form_submitted">Close</v-btn>
          <v-btn
            type="submit"
            color="appcolor"
            dark
            @click="submitReportApproval"
            :disabled="form_submitted"
          >
            <span v-show="!form_submitted">SUBMIT</span>
            <span v-show="form_submitted">
              <v-progress-circular indeterminate color="blue-grey"></v-progress-circular>
            </span>
          </v-btn>
        </span>
      </customDialog>

       <!-- File upload dialog -->
      <customDialog :dialogProps="dialogProps" v-if="isUploadShown">
        <!-- title card -->
        <span
          slot="card-title"
          class="captalize"
        >Form Upload</span>
        <!-- card body -->
        <span slot="card-body">
          <!-- form for add or edit or delete -->
          <v-form ref="form_2" v-model="valid" autocomplete="off">
            <v-row>
              <v-col cols="12">
                Inspection :
                <span
                  v-for="(insp, i) in form.inspection"
                  :key="i"
                >"{{insp.inspection_date}}"</span>
              </v-col>
              <v-col cols="12">Report : {{form.report}}</v-col>
              <v-col cols="12">
                <v-file-input
                  label="Completion Form"
                  type="file"
                  accept=".pdf"
                  @change="handleFileUpload"
                ></v-file-input>
              </v-col>
            </v-row>
          </v-form>
        </span>
        <!-- card action buttons -->
        <span slot="card-action">
          <v-btn text @click="dialogProps.dialog = false" :disabled="form_submitted">Close</v-btn>
          <v-btn
            type="submit"
            color="appcolor"
            dark
            @click="submitFormUpload"
            :disabled="form_submitted"
          >
            <span v-show="!form_submitted">SUBMIT</span>
            <span v-show="form_submitted">
              <v-progress-circular indeterminate color="blue-grey"></v-progress-circular>
            </span>
          </v-btn>
        </span>
      </customDialog>
    </v-container>
  </div>
</template>

<script>
import Mixins from "@/mixin";
import AdminAPI from "@/services/admin_api";
import Config from "@/config.js";
import customDialog from "@/components/custom-dialog";

export default {
  name: "inspection-status",
  mixins: [Mixins],
  components: {
    customDialog
  },
  data() {
    return {
      reportBase: Config.reportBase,

      // breadcrumb
      breadcrumbItems: [
        {
          text: "Inspection status",
          disabled: false,
          to: { name: "inspection-status" },
          exact: true
        }
      ],

      // table props
      tableProps: {
        loading: false,
        tableHeader: "Email logs",
        headerChip: null,
        headerButton: false,
        headerButtonLabel: "email",
        headerListLabel: "Filter by mail id :",
        headerList: [],
        index: true,
        action_button_view: true,
        action_button_edit: true,
        action_button_delete: true,
        headers: [
          { text: "S.No", align: "left", value: "index", sortable: false },
          { text: "Feeder", align: "center", value: "feeder" },
          { text: "Poles", align: "center", value: "poles" },
          { text: "Spans", align: "center", value: "spans" },
          { text: "Report Date 	", align: "center", value: "report_date" },
          {
            text: "Aerodyne Approval",
            align: "center",
            value: "aerodyne_approval"
          },
          { text: "TNB Approval", align: "center", value: "tnb_approval" },
          { text: "Action", align: "center", value: "action", sortable: false }
        ],
        items: []
      },

      // zone, state, subzone, station, source, feeder, section, inspection
      level_list: {
        zone: [],
        state: [],
        subzone: [],
        station: [],
        source: [],
        feeder: [],
        section: [],
        inspection: []
      },

      // filter query data
      filter_items: {
        zone: null,
        state: null,
        subzone: null,
        station: null,
        source: null,
        feeder: null,
        section: null,
        inspection: null
      },
      last_filtered_value: "",
      last_filtered_ind: "",

      // modal
      // dialog props
      dialogProps: {
        dialog: false,
        width: "500px"
      },
      isApproveModalShown: false,
      isRejectModalShown: false,
      isUploadShown: false,

      // form to submit approve or rework
      checkedInspection: [],
      form_submitted: false,
      valid: true,
      form: {
        inspection: "",
        inspectionIds: "",
        report: "",
        comments: "",
        docUrl: "",
        approval_status: "",
        date: new Date(),
        approved_by: JSON.parse(atob(localStorage.getItem("user")))._id,
        approver_type: ""
      },
      rules: {
        inspection: [],
        inspectionIds: [this.required("InspectionId")],
        report: [],
        comments: [this.required("Comments")],
        docUrl: [],
        approval_status: [],
        date: [this.required("Date")],
        approved_by: [this.required("Approved by")],
        approver_type: []
      }
    };
  },
  methods: {
    // Report Approval file upload
    handleFileUpload(event) {
      this.form.docUrl = null;
      console.log(event);
      if (event) {
        this.form.docUrl = event;
      }
    },

    // open modal and update form
    reportModal(modal, item) {
      if (item) {
        if (!this.checkedInspection.includes(item._id)) {
          this.checkedInspection.push(item._id);
        }
      }
      console.log(item._id, this.checkedInspection, modal);
      // reset the form and update value
      var self = this;
      Object.keys(this.form).forEach(function(key) {
        self.form[key] = "";
      });

      // show modal
      if (modal === "Approve") {
        this.isApproveModalShown = true;
      } else if (modal === "Rework") {
        this.isRejectModalShown = true;
      } else if (modal === "Upload") {
        this.isUploadShown = true;
      }
      this.dialogProps.dialog = true;

      console.log(this.isApproveModalShown, this.isRejectModalShown, this.isUploadShown)
      // set perfetch data in form
      var checkedInspection = this.checkedInspection;
      var filterReport = this.tableProps.items.filter(function(i) {
        var temp = checkedInspection.filter(function(ins) {
          return ins == i._id;
        });
        if (temp.length > 0) return true;
      });

      // set form value
      this.form.inspection = filterReport;
      this.form.inspectionIds = checkedInspection;
      this.selectedFile = "full-report";
      this.form.report = this.selectedFile;
      this.form.approved_by = JSON.parse(
        atob(localStorage.getItem("user"))
      )._id;
      this.form.date = new Date();
      console.log(this.form);
    },

    // close all modal
    closeModal() {
      this.isApproveModalShown = false;
      this.isRejectModalShown = false;
      this.isUploadShown = false;
      this.dialogProps.dialog = false;
    },

    // submit report approval
    async submitReportApproval() {
      try {
        this.form_submitted = true;
        var allinspection = this.form.inspection;
        this.form.approver_type = "Aerodyne";
        this.form.inspectionIds = this.form.inspectionIds.filter(function(ins) {
          var found = allinspection.find(function(element) {
            return element._id == ins && element.approval_status != "approved";
          });
          return found ? found._id : false;
        });
        this.form.approval_status = this.isApproveModalShown
          ? "approved"
          : "rework";

        // validate form
        if (!this.$refs.form_1.validate())
          return this.alert("warning", "", "Invalid form");

        if (this.form.docUrl) {
          const fd = new FormData();
          fd.append("file", this.form.docUrl, this.form.docUrl.name);
          const docUrl = await AdminAPI.postForm(
            `inspectionfileupload`,
            fd,
            "baseAPIDomain"
          );
          this.form.docUrl = docUrl.data.fileUrl;
        }
        const dataSubmit = await AdminAPI.post(
          `inspection-approval`,
          this.form,
          "baseAPIDomain"
        );
        if (dataSubmit.status != 200)
          return this.alert(
            "warning",
            "",
            "Failed to submit!!Try after sometime!!"
          );
        this.closeModal();
        this.alert("success", "", "Data submitted successfully!!");
        this.tableProps.items = await this.getReportSummaryData(
          this.last_filtered_value,
          this.last_filtered_ind
        );
        this.form_submitted = false;
        this.checkedInspection = [];
      } catch (error) {
        console.log(error);
        this.form_submitted = false;
        this.alert("warning", "", "Failed to submit!!Try after sometime!!");
      }
    },

    // submit form upload
    async submitFormUpload() {
      try {
        this.form_submitted = true;
        // var allinspection = this.form.inspection;
        this.form.approver_type = "Aerodyne";
        this.form.inspectionId = this.form.inspection[0]._id;
        if (!this.form.approver_type) return alert("no approver type found");
        if (!this.form.inspectionId) return alert("no inspection found");
        if (!this.form.docUrl) return alert("no form found");
        const fd = new FormData();
        fd.append("file", this.form.docUrl, this.form.docUrl.name);
        const docUrl = await AdminAPI.postForm(`inspectionfileupload`, fd, "baseAPIDomain");
        this.form.docUrl = docUrl.data.fileUrl;
        const dataSubmit = await AdminAPI.put(
          `inspection-approval-form-submit`,
          this.form,
          "baseAPIDomain"
        );
         if (dataSubmit.status != 200)
          return this.alert(
            "warning",
            "",
            "Failed to submit!!Try after sometime!!"
          );
        
        this.closeModal();
        this.alert("success", "", "Data submitted successfully!!");
         this.tableProps.items = await this.getReportSummaryData(
          this.last_filtered_value,
          this.last_filtered_ind
        );
        this.checkedInspection = [];
      } catch (error) {
        console.log(error);
        this.form_submitted = false;
        this.alert("warning", "", "Failed to submit!!Try after sometime!!");
      }
    },

    // get report sumary data based on filter
    async getReportSummaryData(value, ind) {
      this.tableProps.loading = true;
      let getData = await AdminAPI.get(
        `report-summary/?${ind}=${value}`,
        "baseAPIDomain"
      );
      this.tableProps.loading = false;
      return getData.data;
    },

    // get select level base list
    async selectSeacrhChange(value, ind) {
      this.last_filtered_value = value;
      this.last_filtered_ind = ind;
      let getData;
      if (typeof value !== "undefined") {
        if (ind == "zone") {
          getData = await AdminAPI.get(
            `/zones/${value}?showonly=name&getlist=by_id`
          );
          this.level_list.state = getData.data.states;
        }
        if (ind == "state") {
          getData = await AdminAPI.get(
            `/states/${value}?showonly=name&getlist=by_id`
          );
          this.level_list.subzone = getData.data.places;
        }
        if (ind == "subzone") {
          getData = await AdminAPI.get(
            `/subzones/${value}?showonly=name&getlist=by_id`
          );
          this.level_list.station = getData.data.places;
        }
        if (ind == "station") {
          getData = await AdminAPI.get(
            `/stations/${value}?showonly=name&getlist=by_id`
          );
          this.level_list.source = getData.data.places;
        }
        if (ind == "source") {
          getData = await AdminAPI.get(
            `/sources/${value}?showonly=name&getlist=by_id`
          );
          this.tableProps.items = await this.getReportSummaryData(value, ind);
          this.level_list.feeder = getData.data.places;
        }
        if (ind == "feeder") {
          getData = await AdminAPI.get(
            `/feeders/${value}?showonly=name&getlist=by_id`
          );
          this.tableProps.items = await this.getReportSummaryData(value, ind);
          this.level_list.section = getData.data.places;
        }
        if (ind == "section") {
          getData = await AdminAPI.get(
            `/sections/${value}?showonly=name&getlist=by_id`
          );
          this.tableProps.items = await this.getReportSummaryData(value, ind);
          this.level_list.inspection = getData.data.places;
        }
        if (ind == "inspection") {
          getData = await AdminAPI.get(
            `/inspections/${value}?showonly=name&getlist=by_id`
          );
          this.tableProps.items = await this.getReportSummaryData(value, ind);
          this.poles = getData.data.places;
          this.temp_poles = this.poles;
        }
        console.log(this.tableProps.items);
      } else {
        this.emptyTextBoxes(ind, this.level_list);
        this.emptyTextBoxes(ind, this.filter_items, "val");
      }
    }
  },
  async mounted() {
    let zoneList = await AdminAPI.get(`/zones`);
    this.level_list.zone = zoneList.data;
  }
};
</script>

<style scoped>
.fliter-box {
  margin: 0 auto;
}
</style>